import { Component, Input } from '@angular/core';

//* Marks a question whose Positive Answer setting is No (Yes and No scores swapped), so whoever answers it knows
@Component({
  selector: 'cygov-inverted-answer-badge',
  templateUrl: './inverted-answer-badge.component.html',
  styleUrls: ['./inverted-answer-badge.component.scss'],
  standalone: false,
})
export class InvertedAnswerBadgeComponent {
  @Input() yesName = 'Yes';
  @Input() noName = 'No';
}
